import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import GUI from 'lil-gui';

/**
 * DEBUG
 */
// const gui = new GUI();

/**
 * CONSTANTS
 */
const SCENE_BACKGROUND_COLOR = 0xFFCDEA
const CUBE_COLOR = 0xBC7FCD
const CUBE_COLOR_INTERACTED = 0xFB9AD1

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Listen resize events
 */
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera aspect ratio to match new canvas dimensions
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)

    // update renderer pixel ratio to match new canvas dimensions
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(SCENE_BACKGROUND_COLOR)

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.set(6, 7, 10)
scene.add(camera)

/**
 * Controls
 */
const controls = new OrbitControls(camera, canvas)
controls.enabled = true
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Cube
const cubeGeometry = new THREE.BoxGeometry(1, 1, 1)

const totalCubes = 100;
const cubes = [];

for (let i = 0; i < totalCubes; i++) {
    const cubeMaterial = new THREE.MeshBasicMaterial({ color: CUBE_COLOR })
    const cube = new THREE.Mesh(cubeGeometry, cubeMaterial)
    cube.position.set(0, 0, 0)

    cube.userData.targetPosition = new THREE.Vector3(
        (Math.random() - 0.5) * 20,
        (Math.random() - 0.5) * 20,
        (Math.random() - 0.5) * 20
    )

    scene.add(cube)
    cubes.push(cube)
}

/**
 * Raycaster and Mouse interaction
 */
const mouse = new THREE.Vector2()

// Mouse move event listener
window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX / sizes.width) * 2 - 1
    mouse.y = -(event.clientY / sizes.height) * 2 + 1

    const raycaster = new THREE.Raycaster()
    raycaster.setFromCamera(mouse, camera)
    const intersections = raycaster.intersectObjects(scene.children)
    
    // Reset all cube colors
    scene.children.forEach(child => {
        if (child instanceof THREE.Mesh) {
            child.material.color.set(CUBE_COLOR)
        }
    })

    // Change color of intersected cube
    if (intersections.length > 0) {
        const cube = intersections[0].object
        cube.material.color.set(CUBE_COLOR_INTERACTED)
    }
})

// Add this function to reset the cubes
function resetCubes() {
    // Remove existing cubes from the scene
    cubes.forEach(cube => scene.remove(cube));
    cubes.length = 0;  // Clear the cubes array

    // Generate new cubes
    for (let i = 0; i < totalCubes; i++) {
        const cubeMaterial = new THREE.MeshBasicMaterial({ color: CUBE_COLOR })
        const cube = new THREE.Mesh(cubeGeometry, cubeMaterial)
        cube.position.set(0, 0, 0)

        cube.userData.targetPosition = new THREE.Vector3(
            (Math.random() - 0.5) * 20,
            (Math.random() - 0.5) * 20,
            (Math.random() - 0.5) * 20
        )

        scene.add(cube)
        cubes.push(cube)
    }
}

// Add this after your other event listeners
document.getElementById('resetButton').addEventListener('click', resetCubes);

// Animate
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update cube positions
    cubes.forEach(cube => {
        cube.position.lerp(cube.userData.targetPosition, 0.01)
    })

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

// Initial cube generation
resetCubes();

tick()
